import React from 'react'
import { Button, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { usePersonPageParams } from '../../personPageRouteUtil'
import AddNoteButton from '../../components/collaborate/AddNoteButton'
import { NotesSkeleton } from './NotesSkeleton'

export default function MiniNotesSkeleton(): JSX.Element {
  const [t] = useTranslation()
  const { pid } = usePersonPageParams('partial')

  return (
    <>
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <AddNoteButton disabled />
      <Separator size="nano" />
      <NotesSkeleton />
      <Separator size="nano" />
      {pid && (
        <Button data-testid="show-all" linkName="Mini Notes: Show All" to={`/collaborate/${pid}`}>
          {t('tree-person.show-all.action')}
        </Button>
      )}
    </>
  )
}
